import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const CHAPTERS = [
  {
    n: "01",
    title: "Structured Batches",
    text: "OTET Paper 1 & 2 covered end to end — syllabus mapping, weekly plans and Odia-medium friendly classes that respect your pace.",
  },
  {
    n: "02",
    title: "Mentorship That Stays",
    text: "Personal mentors track your mocks, clear doubts via WhatsApp / approved communication medium, share personalised weak-concept PDF and audio notes, and personalised mind maps as per add-on services opted (excluding the current batch subscription) — and keep you accountable till exam day.",
  },
  {
    n: "03",
    title: "Practice Until Liberation",
    text: "Trains you thoroughly on OTET syllabus concepts, so you can avoid being surprised during exam.",
  },
];

export const Chapters = () => (
  <section className="relative py-28 sm:py-36" data-testid="manifesto-chapters">
    <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-14">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-sky-700"
      >
        The Jyoti Way
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ delay: 0.1, duration: 0.8, ease: EASE }}
        className="mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl"
      >
        Three promises, kept every single week.
      </motion.h2>

      <div className="mt-16 space-y-0 divide-y divide-slate-200 border-t border-b border-slate-200">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.12, duration: 0.8, ease: EASE }}
            className="group grid gap-4 py-10 transition-colors duration-300 hover:bg-sky-50/60 sm:grid-cols-12 sm:items-baseline sm:px-6"
            data-testid={`chapter-${c.n}`}
          >
            <span className="font-mono text-sm font-bold text-amber-600 sm:col-span-2">{c.n}</span>
            <h3 className="font-display text-2xl font-bold text-slate-900 transition-colors duration-300 group-hover:text-sky-800 sm:col-span-4 sm:text-3xl">
              {c.title}
            </h3>
            <p className="text-base leading-relaxed text-slate-600 sm:col-span-6">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
